module.exports = __webpack_public_path__ + "static/img/057.6b51f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/057.png
// module id = S1hg
// module chunks = 0